import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const ForgotPassword = () => {
  useEffect(() => {
    document.documentElement.classList.add('login-page');
    return () => {
      document.documentElement.classList.remove('login-page');
    };
  }, []);

  return (
    <>
      <div className="p-4 flex flex-col items-start max-w-sm mx-auto h-dvh overflow-hidden pt-20 mb-20">
        <div className="flex items-center w-full py-8 border-b border-border/80">
          <h1 className="text-lg font-medium">Stores for ecommerce</h1>
        </div>

        <div className="flex flex-col items-start gap-y-6 py-8 w-full px-0.5">
          <h2 className="text-2xl font-semibold">Password resets are handled in MyPursePay</h2>
          <div className="w-full rounded-lg border border-border bg-muted/40 p-4 text-sm text-muted-foreground">
            <p>To reset your password, open the MyPursePay app or dashboard and use its account recovery tools. Once your password is updated there, return to Stores and sign in with the same credentials.</p>
            <p className="mt-3">If you need assistance, contact the MyPursePay support team.</p>
          </div>
        </div>

        <div className="flex items-start mt-auto border-t border-border/80 py-6 w-full">
          <p className="text-sm text-muted-foreground">
            Ready to continue?{' '}
            <Link to="/login" className="text-primary">
              Back to sign in
            </Link>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ForgotPassword;